/**
 * The two browser-side helpers of «Килограммы» (ticket 17): the month as Tashkent
 * reads it, and saving the server's Excel file.
 */

/** The file the server built: its name and its bytes in base64. */
export interface Base64File {
	fileName: string
	base64: string
}

/** Saves the server's file in the browser: its bytes as a Blob, downloaded under its name. */
export function saveBase64File(file: Base64File): void {
	const bytes = Uint8Array.from(atob(file.base64), (c) => c.charCodeAt(0))
	const blob = new Blob([bytes], {
		type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	})
	const url = URL.createObjectURL(blob)
	const a = document.createElement('a')
	a.href = url
	a.download = file.fileName
	document.body.appendChild(a)
	a.click()
	a.remove()
	URL.revokeObjectURL(url)
}

/** Tashkent is UTC+5 all year: the month it is there, `YYYY-MM`, `back` months before. */
export function tashkentMonth(now: Date, back = 0): string {
	const local = new Date(now.getTime() + 5 * 60 * 60 * 1000)
	const d = new Date(Date.UTC(local.getUTCFullYear(), local.getUTCMonth() - back, 1))
	return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}`
}

